import React from 'react';
import {createStackNavigator} from '@react-navigation/stack';
import AppRoutes from 'src/AppRoutes';
import StackTransitionPreset from './StackTransitionPreset';
import DeviceInfo from 'src/nativeModules/DeviceInfo';
import AccountFundingScreen from 'src/components/screens/funding/AccountFundingScreen';
import AutoReloadScreen from 'src/components/screens/funding/AutoReloadScreen';
import MainConsumerScreen from 'src/components/screens/MainConsumerScreen';
import PrivacyPolicyScreen from 'src/components/screens/account/PrivacyPolicyScreen';
import BalancesScreen from 'src/components/screens/account/BalancesScreen';
import RedeemRewardScreen from 'src/components/elements/rewards/RedeemRewardScreen';
import ServerErrorDialog from 'src/components/elements/ServerErrorDialog';
import RewardsScanProductScreen from 'src/components/elements/rewards/RewardsScanProductScreen';
import NewMobileOrderLocationScreen from 'src/components/elements/rewards/NewMobileOrderLocationScreen';
import CashRewardRedeemScreen from 'src/components/elements/rewards/CashRewardRedeemScreen';
import CardsScreen from 'src/components/screens/funding/CreditCardsScreen/CreditCardsScreen';
import RewardsAddCreditCard from 'src/components/screens/rewards/RewardsAddCreditCard';
import RewardsAddBirthday from 'src/components/screens/rewards/RewardsAddBirthday';
import AddPhoneNumber from 'src/components/screens/rewards/phoneNumber/AddPhoneNumber';
import VerifyPhoneNumber from 'src/components/screens/rewards/phoneNumber/VerifyPhoneNumber';
import DisclaimerScreen from 'src/components/screens/orderAhead/DisclaimerScreen';

const Stack = createStackNavigator();
export default function MainConsumerNavigator() {
  return (
    <Stack.Navigator
      screenOptions={{
        ...StackTransitionPreset,
        title: DeviceInfo.getApplicationName(),
        headerShown: false,
      }}
    >
      <Stack.Screen name={AppRoutes.Main} component={MainConsumerScreen} />
      <Stack.Screen
        name={AppRoutes.PrivacyPolicy}
        component={PrivacyPolicyScreen}
      />
      <Stack.Screen name={AppRoutes.MyModal} component={AccountFundingScreen} />
      <Stack.Screen
        name={AppRoutes.AutoReloadPanel}
        component={AutoReloadScreen}
      />
      <Stack.Screen
        name={AppRoutes.RedeemRewardPanel}
        component={RedeemRewardScreen}
        options={{
          presentation: 'transparentModal',
          cardStyle: {backgroundColor: 'transparent'},
          headerShown: false,
        }}
      />
      <Stack.Screen
        name={AppRoutes.ServerErrorDialog}
        component={ServerErrorDialog}
      />
      <Stack.Screen name={AppRoutes.Balances} component={BalancesScreen} />
      <Stack.Screen
        name={AppRoutes.RewardsScanProduct}
        component={RewardsScanProductScreen}
      />
      <Stack.Screen
        name={AppRoutes.NewMobileOrderLocation}
        component={NewMobileOrderLocationScreen}
      />
      <Stack.Screen
        name={AppRoutes.RedeemCashReward}
        component={CashRewardRedeemScreen}
        options={{
          presentation: 'transparentModal',
          cardStyle: {backgroundColor: 'transparent'},
          headerShown: false,
        }}
      />
      <Stack.Screen name={AppRoutes.Cards} component={CardsScreen} />
      <Stack.Screen
        name={AppRoutes.RewardsAddCreditCard}
        component={RewardsAddCreditCard}
        options={{
          presentation: 'transparentModal',
          cardStyle: {backgroundColor: 'transparent'},
          headerShown: false,
        }}
      />
      <Stack.Screen
        name={AppRoutes.RewardsAddBirthday}
        component={RewardsAddBirthday}
        options={{
          presentation: 'transparentModal',
          cardStyle: {backgroundColor: 'transparent'},
          headerShown: false,
        }}
      />
      <Stack.Screen
        name={AppRoutes.AddPhoneNumber}
        component={AddPhoneNumber}
        options={{
          presentation: 'transparentModal',
          cardStyle: {backgroundColor: 'transparent'},
          headerShown: false,
        }}
      />
      <Stack.Screen
        name={AppRoutes.VerifyPhoneNumber}
        component={VerifyPhoneNumber}
        options={{
          presentation: 'transparentModal',
          cardStyle: {backgroundColor: 'transparent'},
          headerShown: false,
        }}
      />
      <Stack.Screen name={AppRoutes.Disclaimer} component={DisclaimerScreen} />
    </Stack.Navigator>
  );
}
